export default {"src":"/_next/static/media/discover-daycations-mobile.cd34574f.svg","height":48,"width":40};